/*
 * One bundle serves every stage: a deployment writes the stage values into
 * config.js next to index.html, which sets window.stageConfig before the
 * bundle runs. A value missing there falls back to the env file of the build,
 * so a local build and the dev server work as before.
 */
type RuntimeConfig = Partial<
  Record<
    | 'REACT_APP_API_BASE_URL'
    | 'REACT_APP_OIDC_AUTHORITY'
    | 'REACT_APP_OIDC_CLIENT_ID'
    | 'REACT_APP_OIDC_REDIRECT_URI'
    | 'REACT_APP_MOCK_API',
    string
  >
>;

declare global {
  interface Window {
    stageConfig?: RuntimeConfig;
  }
}

const runtime = (): RuntimeConfig =>
  (typeof window !== 'undefined' && window.stageConfig) || {};

//the process.env names stay literal, webpack replaces only those
export const apiBaseUrl = (): string | undefined =>
  runtime().REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL;

export const oidcAuthority = (): string | undefined =>
  runtime().REACT_APP_OIDC_AUTHORITY ?? process.env.REACT_APP_OIDC_AUTHORITY;

export const oidcClientId = (): string | undefined =>
  runtime().REACT_APP_OIDC_CLIENT_ID ?? process.env.REACT_APP_OIDC_CLIENT_ID;

export const oidcRedirectUri = (): string | undefined =>
  runtime().REACT_APP_OIDC_REDIRECT_URI ??
  process.env.REACT_APP_OIDC_REDIRECT_URI;

export const mockApi = (): boolean =>
  (runtime().REACT_APP_MOCK_API ?? process.env.REACT_APP_MOCK_API) === 'true';
